import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/salario-base-de-cotizacion-variable';

/**
 * GET SBCDetallevariables
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSBCvariables = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET SBCDetallevariables
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSBCvariablesParams = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET SBCDetallevariable
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSBCvariable = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST SBCDetallevariable
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSBCvariable = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SBCDetallevariable
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSBCvariable = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE SBCDetallevariable
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSBCvariable = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR SBCDetallevariables
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarSBvariables = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Progreso de cálculo en tiempo real (cuenta empleados ya calculados)
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getProgresoCalculoSBC = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}/progreso-calculo`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
